const locales = {
  home: `Home`,
  projects: `Projects`,
  instagram: `Instagram`,
}

export default locales
